<script setup lang="ts">
import { useRateMessage } from "@/composables/useRateMessage";

const { id = "" } = defineProps<{
  id?: string;
}>();

const emit = defineEmits(["like", "dislike"]);

const { like, dislike } = useRateMessage();

const rated = ref(false);

const onLike = () => {
  rated.value = true;
  like(id);
  emit("like");
};

const onDislike = () => {
  rated.value = true;
  dislike(id);
  emit("dislike");
};
</script>

<template>
  <div class="chat-message-rating">
    <transition name="fade" mode="out-in">
      <BaseIcon v-if="rated" key="check" name="check" class="check" />

      <div v-else class="rate">
        <BaseIcon key="like" name="thumb_up" class="like" @click="onLike" />
        <BaseIcon
          key="dislike"
          name="thumb_down"
          class="dislike"
          @click="onDislike"
        />
      </div>
    </transition>
  </div>
</template>

<style lang="scss" scoped>
.chat-message-rating {
  align-self: flex-end;
  height: 1.1rem;

  * {
    font-size: 1.1rem;
  }
}

.rate {
  display: flex;
  gap: 1em;
}

.like,
.dislike {
  transition: all 0.15s ease-in-out;
  cursor: pointer;

  &:hover {
    transform: scale(1.2);
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 200ms ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
